// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditTable {\n  height: calc(100% - 155px);\n  -ms-flex-negative: 1;\n      flex-shrink: 1;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: auto;\n}\n.EditTable .tabel-warp {\n  height: 100%;\n}\n.EditTable .pagination-warp {\n  background-color: #fff;\n  margin-top: 12px;\n}\n.EditTable .pagination-warp .el-pager .number {\n  border-radius: 50px;\n}", ""]);
// Exports
module.exports = exports;
